import { useState } from "react";
import Footer from "../Component/Footer";

/*
  Tailwind setup: add these to tailwind.config.js -> theme.extend
    fontFamily: { sans: ['"Plus Jakarta Sans"', "ui-sans-serif", "system-ui", "sans-serif"] },
    colors: { sky1: "#c9ecfb", sky2: "#eaf7fd", lav: "#efeefc", sun: "#f7d94c", ink: "#1c2230", mute: "#7b8494", page: "#f6f7f9" }
  and load the font:
    https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap
*/

/* ---------- Data ---------- */

const NAV = [
  { section: "MENU" },
  { label: "Dashboard", icon: <path d="M4 11l8-7 8 7v8a1 1 0 01-1 1H5a1 1 0 01-1-1z" /> },
  { label: "Teachers", active: true, icon: <><path d="M2 9l10-5 10 5-10 5z" /><path d="M6 11v5c3 3 9 3 12 0v-5" /></> },
  { label: "Students", icon: <><circle cx="9" cy="8" r="3" /><path d="M3 20c0-3 3-5 6-5s6 2 6 5" /><circle cx="17" cy="9" r="2" /></> },
  { label: "Attendance", icon: <><circle cx="8" cy="7" r="2" /><circle cx="16" cy="7" r="2" /><circle cx="12" cy="13" r="2" /><circle cx="6" cy="18" r="2" /><circle cx="18" cy="18" r="2" /></> },
  { label: "Notice", icon: <><rect x="4" y="3" width="16" height="18" rx="3" /><path d="M8 9h8M8 13h5" /></> },
  { label: "Calendar", icon: <><rect x="4" y="4" width="16" height="17" rx="3" /><path d="M8 2v4M16 2v4" /></> },
  { label: "Library", icon: <path d="M3 5l9 2 9-2v14l-9 2-9-2zM12 7v14" /> },
  { section: "OTHER" },
  { label: "Profile", icon: <><circle cx="12" cy="12" r="9" /><circle cx="12" cy="10" r="3" /><path d="M6 18c1-3 3-4 6-4s5 1 6 4" /></> },
  { label: "Setting", icon: <><circle cx="12" cy="12" r="3" /><path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M5 19l2-2M17 7l2-2" /></> },
  { label: "Log out", icon: <path d="M10 4H5v16h5M15 8l4 4-4 4M19 12H9" /> },
];

const TEACHERS = [
  { name: "Ms. Elizabeth Johnson", email: "johnson", id: "SJ-ENG-123", subject: "English Literature", classes: "9A, 10B", phone: "0101",  grad: "from-rose-300 to-rose-500" },
  { name: "Mr. Carlos Garcia", email: "garcia", id: "GRC-HIS-456", subject: "History", classes: "8C, 11A", phone: "0102",  grad: "from-slate-500 to-slate-800" },
  { name: "Ms. Angela Jackson", email: "jackson", id: "JCK-MATH-789", subject: "Math", classes: "7A, 12 AP Calculus", phone: "0103", grad: "from-amber-300 to-orange-500" },
  { name: "Mr. Luis Rodrige", email: "rodrige", id: "ROD-DRA-012", subject: "Drama", classes: "Drama Club", phone: "0104",  grad: "from-sky-300 to-sky-600" },
  { name: "Ms. Susan Chen", email: "chen", id: "CHN-SCI-345", subject: "Science", classes: "8B, 9B Biology", phone: "0105",  grad: "from-teal-300 to-teal-600" },
  { name: "Mr. William Blake", email: "blake", id: "THM-HIS-678", subject: "History", classes: "10A, 11 AP World History", phone: "0106",  grad: "from-zinc-500 to-zinc-800" },
  { name: "Ms. Emily Lee", email: "lee", id: "LEE-ENG-901", subject: "English", classes: "7B, 8A", phone: "0107",  grad: "from-cyan-300 to-blue-500" },
  { name: "Mr. Fernando Davis", email: "davis", id: "HER-SPA-234", subject: "Spanish", classes: "Spanish I, Spanish II", phone: "0108", grad: "from-indigo-400 to-indigo-700" },
  { name: "Ms. Laura Lopez", email: "lopez", id: "LOP-MATH-567", subject: "Math", classes: "7C, Pre-Algebra", phone: "0109",  grad: "from-yellow-300 to-amber-500" },
  { name: "Mr. Daniel Kim", email: "kim", id: "KIM-ART-890", subject: "Art", classes: "Art I, Art II", phone: "0110",  grad: "from-blue-400 to-blue-700" },
];

/* ---------- Small pieces ---------- */

const Icon = ({ children, className = "h-5 w-5" }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" aria-hidden="true">
    {children}
  </svg>
);

const SearchIcon = () => (
  <Icon className="h-4 w-4 text-mute"><circle cx="11" cy="11" r="7" /><path d="M21 21l-4-4" /></Icon>
);

const RowActions = () => (
  <div className="flex gap-3 text-slate-400">
    <button aria-label="Edit" className="hover:text-ink">
      <Icon><path d="M12 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2v-6" /><path d="M18 3l3 3-9 9-4 1 1-4z" /></Icon>
    </button>
    <button aria-label="Delete" className="hover:text-ink">
      <Icon><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6" /></Icon>
    </button>
    <button aria-label="More" className="hover:text-ink">
      <Icon><rect x="3" y="3" width="18" height="18" rx="4" /><path d="M8 12h.01M12 12h.01M16 12h.01" /></Icon>
    </button>
  </div>
);

const Checkbox = ({ label, ...props }) => (
  <input type="checkbox" aria-label={label} className="h-4 w-4 rounded border-slate-300 accent-sky-500" {...props} />
);

/* ---------- Sections ---------- */

function Sidebar() {
  return (
    <aside className="sticky top-0 hidden h-screen w-[250px] shrink-0 flex-col px-5 pb-5 pt-8 lg:flex">
      <a href="#" className="flex items-center gap-2 px-1 text-xl font-bold">
        <svg className="h-6 w-6 text-sky-400" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M12 2l3 4h4v5a7 7 0 01-14 0V6h4zM9 11a1 1 0 100 2 1 1 0 000-2zm6 0a1 1 0 100 2 1 1 0 000-2z" />
        </svg>
        School monitor
      </a>

      <nav className="mt-10 flex-1 overflow-y-auto text-sm  
            [&::-webkit-scrollbar]:w-2 
          [&::-webkit-scrollbar-track]:bg-white 
          [&::-webkit-scrollbar-thumb]:bg-blue-500 
            [&::-webkit-scrollbar-thumb]:rounded-full" aria-label="Main">
        {NAV.map((item) =>
          item.section ? (
            <p key={item.section} className={`${item.section === "OTHER" ? "mt-8" : ""} mb-3 px-2 text-xs uppercase text-mute`}>
              {item.section}
            </p>
          ) : (
            <a
              key={item.label}
              href="#"
              aria-current={item.active ? "page" : undefined}
              className={`mb-1 flex items-center gap-3 rounded-xl px-3 py-3 ${item.active ? "bg-sky1 font-medium text-ink" : "text-mute hover:bg-white"}`}
            >
              <Icon>{item.icon}</Icon>
              <span className="flex-1">{item.label}</span>
              {item.chevron && "›"}
            </a>
          )
        )}
      </nav>

      <div className="relative mt-4 h-[180px] overflow-hidden rounded-2xl bg-gradient-to-br from-cyan-300 via-sky-500 to-blue-900 p-4 text-white">
        <p className="text-[15px] font-semibold leading-snug text-white/90">Let’s Manage Your Data Better in Your Hand</p>
        <button className="absolute inset-x-4 bottom-4 rounded-full bg-blue py-2.5 text-xs font-semibold text-ink hover:text-white ">Download the App</button>
      </div>
    </aside>
  );
}

function TopBar() {
  return (
    <header className="flex items-center justify-between gap-4">
      <label className="flex w-full max-w-[290px] items-center gap-2 rounded-full border border-slate-300 px-4 py-2.5">
        <SearchIcon />
        <input type="search" placeholder="Search" className="w-full bg-transparent text-sm outline-none placeholder:text-mute border-none" />
      </label>

      <div className="flex items-center gap-3">
        <button aria-label="Messages" className="grid h-11 w-11 place-items-center rounded-full bg-blue-400 shadow-sm">
          <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24"><path d="M4 4h12a2 2 0 012 2v6a2 2 0 01-2 2H9l-4 3v-3H4a2 2 0 01-2-2V6a2 2 0 012-2zm16 5v6a2 2 0 01-2 2v3l-3-2h-4l2-2h5a1 1 0 001-1V9z" /></svg>
        </button>
        <button aria-label="Notifications" className="grid h-11 w-11 place-items-center rounded-full bg-blue-400 shadow-sm">
          <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2a6 6 0 00-6 6v4l-2 3v1h16v-1l-2-3V8a6 6 0 00-6-6zm-2 17a2 2 0 004 0z" /></svg>
        </button>
        <div className="ml-2 text-right leading-tight">
          <p className="text-sm font-semibold">Linda Adobi</p>
          <p className="text-[11px] text-mute">Teacher</p>
        </div>
        <div className="relative grid h-11 w-11 place-items-center rounded-full bg-gradient-to-br from-sky-200 to-sky-400 text-xs font-bold text-white">
          LA
          <span className="absolute bottom-0 right-0 h-2.5 w-2.5 rounded-full border-2 border-white bg-emerald-500" />
        </div>
      </div>
    </header>
  );
}



function TeacherRow({ teacher, selected, onToggle }) {
  const initials = teacher.name.split(" ").slice(1).map((w) => w[0]).join("");
  return (
    <tr className={selected ? "bg-lav" : "hover:bg-slate-50"}>
      <td className="py-4 pl-4">
        <Checkbox label={`Select ${teacher.name}`} checked={selected} onChange={onToggle} />
      </td>
      <td className="py-4 pl-3">
        <div className="flex items-center gap-3">
          <span className={`grid h-[46px] w-[46px] shrink-0 place-items-center rounded-full bg-gradient-to-br ${teacher.grad} text-xs font-semibold text-white`}>
            {initials}
          </span>
          <div>
            <p className="font-medium">{teacher.name}</p>
            <p className="text-xs text-mute">{teacher.email}@eduprohigh.edu</p>
          </div>
        </div>
      </td>
      <td className="pr-4">{teacher.id}</td>
      <td className="max-w-[120px] pr-4">{teacher.subject}</td>
      <td className="max-w-[130px] pr-4">{teacher.classes}</td>
      <td className="whitespace-nowrap pr-4">(555) 101-{teacher.phone}</td>
      <td className="pr-4"><RowActions /></td>
    </tr>
  );
}





function TeachersTable({ teachers, selected, setSelected }) {
  const allSelected = teachers.length > 0 && teachers.every((t) => selected.has(t.id));

  const toggleOne = (id) =>
    setSelected((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });

  const toggleAll = () => setSelected(allSelected ? new Set() : new Set(teachers.map((t) => t.id)));

  return (
    <div className="mt-6 overflow-x-auto">
      <table className="w-full min-w-[900px] text-left text-sm">
        <thead>
          <tr className="bg-sky2 text-[13px] font-medium">
            <th className="w-12 rounded-tl-xl py-4 pl-4">
              <Checkbox label="Select all" checked={allSelected} onChange={toggleAll} />
            </th>
            <th className="py-4 pl-3">Teacher Name</th>
            <th>School ID</th>
            <th>Subject</th>
            <th>Class</th>
            <th>Phone Number</th>

            <th className="rounded-tr-xl pr-4">Action</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {teachers.map((t) => (
            <TeacherRow key={t.id} teacher={t} selected={selected.has(t.id)} onToggle={() => toggleOne(t.id)} />
          ))}
        </tbody>
      </table>
    </div>
  );
}



function Pagination({ page, setPage }) {
  const pages = [1, 2, 3, 4, "…", 17];
  return (
    <nav className="mt-5 flex items-center justify-between text-sm text-mute" aria-label="Pagination">
      <button aria-label="Previous page" onClick={() => setPage((p) => Math.max(1, p - 1))} className="grid h-8 w-8 place-items-center rounded-lg border border-slate-300 hover:bg-slate-50">‹</button>
      <ol className="flex items-center gap-4">
        {pages.map((p, i) => (
          <li key={i}>
            {p === "…" ? (
              "…"
            ) : (
              <button
                onClick={() => setPage(p)}
                aria-current={p === page ? "page" : undefined}
                className={p === page ? "rounded bg-sky2 px-2 py-1 font-semibold text-ink" : "px-2 py-1 hover:text-ink"}
              >
                {p}
              </button>
            )}
          </li>
        ))}
      </ol>
      <button aria-label="Next page" onClick={() => setPage((p) => Math.min(17, p + 1))} className="grid h-8 w-8 place-items-center rounded-lg border border-slate-300 hover:bg-slate-50">›</button>
    </nav>
  );
}










export default function SchoolConsole() {
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const [selected, setSelected] = useState(() => new Set(["GRC-HIS-456"]));

  const q = query.trim().toLowerCase();
  const visible = q ? TEACHERS.filter((t) => [t.id, t.name, t.subject].some((v) => v.toLowerCase().includes(q)))
                      : TEACHERS;

  return (
    <>
    <div className="flex min-h-screen bg-page font-sans text-ink">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col px-4 py-6 lg:pl-0 lg:pr-5">
        <TopBar />

        <main className="mt-6 flex-1 rounded-3xl bg-white p-5 shadow-sm">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <h1 className="text-xl font-semibold">All Teachers List</h1>
            <div className="flex items-center gap-3">
              <label className="flex w-[300px] max-w-full items-center gap-2 rounded-full border border-slate-200 px-4 py-2.5">
                <SearchIcon />
                <input
                  type="search"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder="Search by ID, Name, or Class"
                  className="w-full text-sm outline-none placeholder:text-mute
                  border-none"
                />
              </label>
              <button aria-label="Adjust" className="grid h-10 w-10 place-items-center rounded-full bg-sun">
                <Icon className="h-4 w-4"><path d="M4 8h10M18 8h2M4 16h2M10 16h10" /><circle cx="16" cy="8" r="2" /><circle cx="8" cy="16" r="2" /></Icon>
              </button>
              <button aria-label="Filter" className="grid h-10 w-10 place-items-center rounded-full bg-sun">
                <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24"><path d="M3 4h18l-7 9v6l-4 2v-8z" /></svg>
              </button>
              <button aria-label="Add teacher" className="grid h-10 w-10 place-items-center rounded-full bg-sun">
                <Icon className="h-4 w-4"><path d="M12 5v14M5 12h14" /></Icon>
              </button>
            </div>
          </div>

          <TeachersTable teachers={visible} selected={selected} setSelected={setSelected} />
          <Pagination page={page} setPage={setPage} />
        </main>
      </div>
    </div>
       <Footer />
    </>
  );
}